var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    fill: "#D4D4DD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.67217 17.5318L11.1967 14.8913C10.7001 14.7536 10.2553 14.4915 9.89804 14.1406L8.37377 16.7807C8.77077 17.0823 9.2065 17.3356 9.67217 17.5318Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0464 12.7499H9.09446C9.0328 12.5102 9 12.259 9 12.0001C9 11.741 9.03283 11.4896 9.09456 11.2499H6.04644C6.01579 11.4956 6 11.746 6 12.0001C6 12.254 6.01577 12.5042 6.0464 12.7499Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37388 7.21935L9.89814 9.85945C10.2555 9.50856 10.7003 9.24643 11.1968 9.10879L9.6723 6.46828C9.20662 6.66447 8.77089 6.91775 8.37388 7.21935Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8031 9.10877L14.3276 6.46826C14.7933 6.66445 15.2291 6.91772 15.6261 7.21931L14.1018 9.85941C13.7445 9.50852 13.2997 9.2464 12.8031 9.10877Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9055 12.7499C14.9672 12.5102 15 12.259 15 12.0001C15 11.741 14.9672 11.4896 14.9054 11.2499H17.9536C17.9842 11.4956 18 11.746 18 12.0001C18 12.254 17.9842 12.5042 17.9536 12.7499H14.9055Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8034 14.8913C13.3 14.7536 13.7447 14.4914 14.102 14.1405L15.6263 16.7806C15.2293 17.0822 14.7936 17.3355 14.3279 17.5317L12.8034 14.8913Z",
    fill: "#D4D4DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTire);
export default __webpack_public_path__ + "static/media/tire.557e72d2df77871913540c36de9edb98.svg";
export { ForwardRef as ReactComponent };